export const GET_ATTRACTION = "GET_ATTRACTION";
export const ADD_ATTRACTION = "ADD_ATTRACTION";
export const UPDATE_ATTRACTION = "UPDATE_ATTRACTION";
export const DELETE_ATTRACTION = "DELETE_ATTRACTION";
